import React from "react";

const HeroSection = ({ title, backgroundImage, subtitle }) => {
  return (
    <div
      className="relative flex items-center justify-center h-56 md:h-56 lg:h-60 w-full text-white text-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-primary bg-opacity-85"></div>

      {/* Content */}
      <div className="relative z-10">
        <h1 className="text-3xl md:text-4xl font-bold">{title}</h1>
        {subtitle && (
          <p className="text-md mt-2">
            <span className="text-white">{subtitle}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default HeroSection;
